import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { getWrapperClasses, getWrapperStyles } from './styles';

/**
 * Static save — nothing here is queried, so there is no reason to pay for a
 * server render. The avatar child inside still renders dynamically; WordPress
 * passes this block's providesContext down to it either way.
 */
export default function Save({ attributes }) {
  const blockProps = useBlockProps.save({
    className: getWrapperClasses(attributes),
    style: getWrapperStyles(attributes),
  });

  const innerBlocksProps = useInnerBlocksProps.save(blockProps);

  return <div {...innerBlocksProps} />;
}
